export const SERVICIO_VALLE_SAGRADO_ID = 2;
export const SERVICIO_MARAS_MORAY_ID = 3;
export const SERVICIO_INTI_RAYMI_ID = 164;
